// extracted by mini-css-extract-plugin
export default {"variable":"variable--dac3fb","variable__name":"variable__name--4754a9","variable__name_tiny":"variable__name_tiny--ffd0e9"};